import React, { FC, SyntheticEvent } from 'react'

import styled from '~/design/styled'

type Props = Readonly<{
  className?: string
  onClick: (event: SyntheticEvent) => void
}>

export const Clickable: FC<Props> = ({ children, onClick, className }) => (
  <Container onClick={onClick} className={className}>
    {children}
  </Container>
)

const Container = styled.span({
  display: 'flex',
  ':hover': {
    cursor: 'pointer',
  },
})
